import React from 'react';

import { noop } from 'dpl/shared/utils';
import { isEmpty } from 'dpl/shared/utils/object';
import customFetch from 'dpl/shared/utils/customFetch';
import { pushToastNotification } from 'dpl/shared/actions/toast_notifications';
import { TOAST_NOTIFICATIONS_TYPES } from 'dpl/shared/constants/shared';

import ErrorToastMessage from './ErrorToastMessage';
import { fullUrl } from './generateQueryKey';
import TptConnectError from './TptConnectError';

export const RESCUABLE_STATUS_CODES = [
  // not found; let user go back
  404,
  // forbidden; most likely stale csrf token. refresh should fix
  403,
  // we eff'd up; let user refresh and hope for the best
  500,
  // likely nginx error (often deploy/mem related)
  502,
  504
];

if (window.__DPL_CURRENT_USER_ID) {
  // useful only when user IS supposed to be logged in but their session has
  // expired. this will show error and let them reload the page which should
  // then redirect to login.
  //
  // we don't want to do this when user is NOT logged in bc 401s in that case
  // could mean failed login and should be already handled by the login
  // component
  RESCUABLE_STATUS_CODES.push(401);
}

export default function createFetchData({
  body,
  headers,
  method = 'GET',
  params = {},
  url
}) {
  const finalUrl = isEmpty(params) ? url : fullUrl(url, params);
  return customFetch(finalUrl, { headers, method, body }).then((res) => {
    if (RESCUABLE_STATUS_CODES.includes(res.status)) {
      window.__DPL_REDUX_STORE.dispatch(pushToastNotification({
        type: TOAST_NOTIFICATIONS_TYPES.ERROR,
        message: <ErrorToastMessage responseCode={ res.status } />,
        timeout: false
      }));

      // TODO: this is temp. remove once found reason for increased 403s
      if (res.status === 403 && window.bugsnagClient) {
        const xsrfCount = (document.cookie.match(/CSRF-TOKEN/g) || []).length;
        window.bugsnagClient.notify(new Error('Server responded with 403'), {
          severity: 'warning',
          metaData: {
            url,
            xsrfCount
          }
        });
      }

      // TODO: this leaks; can probs listen to history changes and resolve
      // this promise if the user decides to continue their session and just
      // navigate away
      return new Promise(noop);
    }

    const contentTypeHeader = res.headers.get('content-type');
    const type = contentTypeHeader && contentTypeHeader.toLowerCase().includes('application/json')
      ? 'json'
      : 'text';
    const response = res.clone();

    return response[type]().then((data) => {
      if (!response.ok) {
        throw new TptConnectError(`Server responded with ${response.status}`, {
          response: res,
          responseBody: data
        });
      }

      return { data, response };
    });
  });
}
